/**
 * This bootstrap file is used for both frontend and backend
 */

import _ from 'lodash'
import axios from 'axios'
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'popper.js'; // Required for BS4
//import 'bootstrap';
import Vue from 'vue';

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = $;
window.Swal = Swal;
window._ = _; // Lodash

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
const token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    // axios 用
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    // jQuery Ajax 用
    $.ajaxSetup({ headers: { 'X-CSRF-TOKEN': token.content } });
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Vue
 * @type {Vue | VueConstructor}
 */
window.Vue = Vue;

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

/*
// 一旦 Pusher 周りは不要なのでコメントアウトしておく
import Echo from 'laravel-echo';
//window.io = require('socket.io-client');
window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    //encrypted: true,
    //forceTls: true,
    authEndpoint: '/broadcasting/auth',
    httpHost: window.location.hostname,
    httpPort: 80,
    httpsPort: 443,
    wsHost: window.location.hostname,
    wsPort: 80,
    wssPort: 443,
    //wsPath: '/pusher',
    disableStats: false,
    auth: {
        headers: {
            'X-CSRF-TOKEN': token.content
        }
    }
});
*/


/**
 * Select2
 */
import 'select2';
// エラーメッセージの日本語化
require("select2/dist/js/i18n/ja");
// グローバルなオプションの指定
$.fn.select2.defaults.set("allowClear", true);  // 空にできるようにする
$.fn.select2.defaults.set("placeholder", "");   // allowClear だけだとエラーになるため
//$.fn.select2.defaults.set("minimumInputLength", 2);
$.fn.select2.defaults.set("width", "100%");     // tdタグの中に入れたときにだんだん大きくなっていくのを防ぐ
//$.fn.select2.defaults.set("theme", "bulma");    // テーマの指定 (sass/_global.scss で bulma の theme を import している)
//$.fn.select2.defaults.set("theme", "bootstrap4");    // テーマの指定 (sass/_global.scss で bootstrap4 の theme を import している)
